import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, ViewChild } from '@angular/core';
import { CommonDataService } from 'src/sb-tools/typescript/services/common-data.service';
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from '@ng-select/ng-select';
import { AssignService } from '../../../core/services/ticket/assign.service';
import { TicketListService } from '@form-field-module/common/services/ticket-list.service';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgClass } from '@angular/common';
import { InlineSVGComponent } from '../../../../sb-modules/Frontend-Inline-SVG-Module/inline-svg.component';
import { UserAvatarComponent } from '../../../../sb-modules/Frontend-User-Avatar-Module/user-avatar.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { ClickOutsideAssignBlockDirective } from '@form-field-module/common/directives/click-outside-assign-block.directive';

@Component({
    selector: 'app-assign-block',
    templateUrl: './assign-block.component.html',
    styleUrls: ['./assign-block.component.scss'],
    imports: [
        TooltipModule,
        NgClass,
        InlineSVGComponent,
        UserAvatarComponent,
        TranslateModule,
        NgSelectComponent,
        FormsModule,
        NgLabelTemplateDirective,
        NgOptionTemplateDirective,
        ClickOutsideAssignBlockDirective,
    ],
})
export class AssignBlockComponent implements OnChanges, OnDestroy {
    @ViewChild('ngSelect') ngSelect: NgSelectComponent;

    @Input() assignee?;
    @Input() isAssigned: boolean;
    @Input() isBulkOperation?: boolean;
    @Input() usersForAssign = [];

    @Output() assignTicket = new EventEmitter();

    assignedUsers = [];
    newAssignee; // add type with label

    constructor(
        public commonDataService: CommonDataService,
        public assignService: AssignService,
        public ticketListService: TicketListService,
    ) {}

    ngOnChanges() {
        this.newAssignee = structuredClone(this.assignee);

        if (this.newAssignee) {
            this.newAssignee.label = this.newAssignee.name || this.newAssignee.email;
        }
        if (this.isBulkOperation) {
            this.assignService.isAssignedToCurrentUser = false;
        } else {
            this.assignService.isAssignedToCurrentUser =
                this.isAssigned && this.newAssignee.id === this.commonDataService.user.id;
            this.assignService.isNotAssignedToCurrentUser = this.assignService.getIsNotAssignedToCurrentUserStatus(
                this.isAssigned,
            );
        }
    }

    closeAssigningSelect($event) {
        if (this.assignedUsers.length) {
            this.assignTicket.emit({
                event: $event,
                data: {
                    isAssigned: true,
                    assignee: this.newAssignee,
                },
            });
        }

        this.assignService.isShowAssigningSelect = false;
    }

    showAssigningSelect($event) {
        if (this.assignService.isAssigningTicket) {
            return;
        }

        $event.stopPropagation();

        if (!this.assignService.isShowAssigningSelect) {
            this.assignService.isShowAssigningSelect = true;
        }

        if (this.assignService.isShowAssigningSelect) {
            setTimeout(() => {
                this.ngSelect.open();
            }, 0);
        }
    }

    unassign($event) {
        this.assignTicket.emit({
            event: $event,
            data: {
                isAssigned: false,
            },
        });
    }

    updateAssignee($event) {
        this.assignTicket.emit({
            event: $event,
            data: {
                isAssigned: !!this.newAssignee,
                assignee: this.newAssignee,
            },
        });
    }

    ngOnDestroy() {
        this.assignService.isShowAssigningSelect = false;
        this.assignService.isAssigningTicket = false;
    }
}
